<template>
  <el-collapse-item
    title="Actions"
    name="actions"
  >
    <section class="drawer-panel-section">
      <div class="actions flex flex-column">
        <ActivateAccount
          :user="user"
          :is-recruiter="true"
        />

        <ChangeAssessments :user="user" />

        <ChangeStatus :user="user" />

        <ExtendAccount :user="user" />

        <AddRecruiter :user="user" />

        <RemoveRecruiter :user="user" />

        <AdvancedReport :user="user" v-if="false" />

        <DeleteAccount :user="user" v-if="!isTurkish"/>

        <ExpandView v-on="$listeners" :expand="expand" />
      </div>
    </section>
  </el-collapse-item>
</template>

<script>
export default {
  name: 'RecruiterActions',
  components: {
    ActivateAccount: () => import('@/components/UserDrawer/Sections/Actions/ActivateAccount'),
    ChangeAssessments: () => import('@/components/UserDrawer/Sections/Actions/ChangeAssessments'),
    ChangeStatus: () => import('@/components/UserDrawer/Sections/Actions/ChangeStatus'),
    ExtendAccount: () => import('@/components/UserDrawer/Sections/Actions/ExtendAccount'),
    AddRecruiter: () => import('@/components/UserDrawer/Sections/Actions/AddRecruiter'),
    RemoveRecruiter: () => import('@/components/UserDrawer/Sections/Actions/RemoveRecruiter'),
    AdvancedReport: () => import('@/components/UserDrawer/Sections/Actions/AdvancedReport'),
    ExpandView: () => import('@/components/UserDrawer/Sections/Actions/ExpandView'),
    DeleteAccount: () => import('@/components/UserDrawer/Sections/Actions/DeleteAccount')
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    expand: {
      type: Boolean
    }
  },
  computed: {
    isTurkish() {
      return this.$store.getters.isTurkish
    }
  }
}
</script>

<style lang="scss">
  @import "~vars";

  .actions .el-button {
    margin: 0 0 $-padding-unit 0;
  }
</style>
